const TOKEN_KEY = 'auth_token';
const UAE_PASS_STATE_KEY = 'uaepass_state';

export const tokenStore = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  set: (token: string): void => localStorage.setItem(TOKEN_KEY, token),
  clear: (): void => localStorage.removeItem(TOKEN_KEY),
  getUaePassState: (): string | null => localStorage.getItem(UAE_PASS_STATE_KEY),
  setUaePassState: (state: string): void => localStorage.setItem(UAE_PASS_STATE_KEY, state),
  clearUaePassState: (): void => localStorage.removeItem(UAE_PASS_STATE_KEY),
};
